module.exports = __webpack_public_path__ + "static/media/tech-assess-2.e4a9649a.png";